import React from 'react'
import logo from '../Images/logo-main-black.png'
import {NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome} from '@fortawesome/free-solid-svg-icons'
import { faUser} from '@fortawesome/free-solid-svg-icons'
import { faBookOpen} from '@fortawesome/free-solid-svg-icons'
import { faClipboardList} from '@fortawesome/free-solid-svg-icons'
import { faComments} from '@fortawesome/free-solid-svg-icons'

// firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";

//routers
import {useNavigate } from "react-router-dom";

function LeftmenuIn() {

    let navigate = useNavigate();

    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {

        if (user) {

        } else {
        // User is signed out
        navigate("/login")
        }
    })

  return (
   <div className='leftNav'>
   
        <img src={logo} alt="" className='dashnavLogo' />
      
      
        <br />
        <p>HOME</p>
        

        <NavLink to="/dashboard" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faHome} className="laftNavIcon activelaftNavIcon"/>
            Dashboard
        </NavLink>

        <NavLink to="/my-courses" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faBookOpen} className="laftNavIcon"/>
            My Courses
        </NavLink>

        <NavLink to="/assignments" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faClipboardList} className="laftNavIcon"/>
            Assignments
        </NavLink>

        <NavLink to="/workspace" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faComments} className="laftNavIcon"/>
            Workspace
        </NavLink>


        {/* <NavLink to="/workshops" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faBriefcase} className="laftNavIcon"/>
            Workshops
        </NavLink> */}

        {/* className={`leftLinkCont d-flex align-items-center ${activeMenu3}`} */}

        {/* <p>RESEARCH & DEV</p> */}

        {/* <NavLink to="/assigned-profects" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faCoffee} className="laftNavIcon"/>
            Client's Projects
        </NavLink> */}
        {/* <NavLink to="/students-reports" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faCalendarDay} className="laftNavIcon "/>
            Students Report
        </NavLink>


        <NavLink to="/my-thoughts" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faQuoteLeft} className="laftNavIcon "/>
            My Thoughts
        </NavLink>

        <NavLink to="/ai-assistant" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
          <FontAwesomeIcon icon={faMagic} className="laftNavIcon "/>
          AI Assistant
        </NavLink> */}
        
        <p>ACCOUNT</p>
        <NavLink to="/profile" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faUser} className="laftNavIcon "/>
            Profile
        </NavLink>


      

    </div>
  )
}

export default LeftmenuIn
